import { emptyPerioTeethData, perioExamJawConfigMap } from './constants';
import { PerioExamTraversalStrategy, PerioExamState, PerioJawConfigTuple } from './models';
import { getPerioExamTraversalStrategy } from './utils';

const defaultPerioExamStrategy: PerioExamTraversalStrategy = 'archWise';
const defaultPerioExamJawConfig: PerioJawConfigTuple = perioExamJawConfigMap[defaultPerioExamStrategy];
const defaultPerioExamToothOrder = getPerioExamTraversalStrategy(defaultPerioExamJawConfig);
const defaultToothPosition = defaultPerioExamToothOrder[0];

export const initialState: PerioExamState = {
  loaded: false,
  teethRecord: emptyPerioTeethData,
  extractedTeethPositions: [],
  missingTeethPositions: [],
  completedSteps: [],
  touchedSteps: [],
  traversalStrategy: defaultPerioExamStrategy,
  toothOrder: defaultPerioExamToothOrder,
  currentToothPosition: defaultToothPosition,
  providerId: undefined,
  cheatSheetOpened: false,
  isEditing: false,
  recessionInputType: 'central',
};
